import React, { useState, useCallback, useRef } from "react";
import { connect } from "react-redux";
import "../../../../css/salesorder.css";
import { GridLayout } from "../../../../../common/GridLayout";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import { Button } from 'devextreme-react';

import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
import SaleOrderDataEntryPopup from "../../salesOrderDataEntry/common/SaleOrderDataEntryPopup";
import MassPickNotesPopup from "../common/MassPickNotesPopup";
import GridOptionsButton from "../../../../../common/GridOptionsButton";
import { ItemOrdersGridOptions } from "../../../../../enum/Enum";

const operationDropDownItems = [
    { id: ItemOrdersGridOptions.MassPickNotesId, name: ItemOrdersGridOptions.MassPickNotesDescription },
];

const tranType = [
    {
        ID: 'C',
        Text: 'Credit - Inventory Effect (In Receiving)',
    },
    {
        ID: 'I',
        Text: 'Order/Invoice - Inventory Effect',
    },
]

const ItemOrdersTabResult = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "71E5F5D9-F1BB-4A3B-A1E4-B9C046F0FAD0";
       const [currentLayout, setCurrentLayout]= useState("Default");
    const saveState = useCallback((state) => {GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const [showPopup, setShowPopup] = useState({id:null,visible:false});
    const [selectedDetailRows, setSelectedDetailRows] = useState([]);
    const [massPickNotesVisible, setMassPickNotesVisible] = useState(false);

    const onOperationItemClick = (e) => {
        if (e.itemData?.id === ItemOrdersGridOptions.MassPickNotesId) {
            setMassPickNotesVisible(true);
        }
    };

    /** Legacy opItemOrderBottomMassPickNoteClick clears the grid selection and refreshes once the
     *  dialog closes — whether or not the notes were saved — so the same lines can't be re-applied. */
    const closeMassPickNotes = useCallback(() => {
        setMassPickNotesVisible(false);
        const grid = dataGrid.current?.instance();
        if (grid) {
            grid.clearSelection();
            grid.refresh();
        }
    }, []);

    const onRowPrepared = (e) => {
        if (e.rowType === 'data') {
            if (e.data.type === 'C') {
                e.rowElement.style.backgroundColor = '#FFCDD2'; // Light red for Inactive
            }
        }
    };
    const onSelectionChanged = ({ selectedRowsData }) => {
        const rows = selectedRowsData || [];
        setSelectedDetailRows(rows);
        const one = rows.length === 1 ? rows[0] : null;
        setShowPopup({ id: one?.rTransactionheader ?? null, visible: false });
    };
    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
             ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                onRowPrepared={onRowPrepared}
                onSelectionChanged={onSelectionChanged}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="multiple"/>
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Column dataField="recordNo" caption='Record #' ></Column>
                <Column dataField="customer" caption='Customer' ></Column>
                <Column dataField="customerName" caption='Customer Name' ></Column>
                <Column dataField="type" caption='Type'
                    lookup={{ dataSource: tranType, valueExpr: 'ID', displayExpr: 'Text' }} cellRender={cellData => {
                        switch (cellData.value) {
                            case 'C':
                                return <span>Credit - Inventory Effect (In Receiving)</span>;
                            case 'I':
                                return <span>Order/Invoice - Inventory Effect</span>;
                            default:
                                return <span>{cellData.value}</span>;
                        }
                    }}
                ></Column>
                <Column dataField="transactionNumber" caption='Transaction #' ></Column>
                <Column dataField="shipDate" dataType="date" caption='Ship Date' ></Column>
                <Column dataField="creationdatetime" dataType="date" caption="Creation DateTime" visible={false}></Column>
                <Column dataField="creationuserid" caption="Creation User ID" visible={false}></Column>
                <Column dataField="lastupdatedatetime" dataType="date" caption="Last Update DateTime" visible={false}></Column>
                <Column dataField="companyid" caption="Company ID" visible={false}></Column>
                <Column dataField="module" caption="Module" visible={false}></Column>
                <Column dataField="recordtype" caption="Record Type" visible={false}></Column>
                <Column dataField="rTransactionheader" caption="Transaction Header" visible={false}></Column>
                <Column dataField="rItem" caption="Item" visible={false}></Column>
                <Column dataField="rWarehouse" caption="Warehouse" visible={false}></Column>
                <Column dataField="rLot" caption="Lot" visible={false}></Column>
                <Column dataField="rProductcategory" caption="Product Category" visible={false}></Column>
                <Column dataField="pickstatus" caption="Pick Status" visible={false}></Column>
                <Column dataField="taxableflag" caption="Taxable Flag" visible={false}></Column>
                <Column dataField="artradediscountflag" caption="AR Trade Discount Flag" visible={false}></Column>
                <Column dataField="artermsdiscountflag" caption="AR Terms Discount Flag" visible={false}></Column>
                <Column dataField="shippingdate" dataType="date" caption="Shipping Date" visible={false}></Column>
                <Column dataField="discountpercent" caption="Discount Percent" visible={false}></Column>
                <Column dataField="unitofmeasure" caption="Unit of Measure" visible={false}></Column>
                <Column dataField="unitprice" caption="Unit Price" visible={false}></Column>
                <Column dataField="amount" caption="Amount" visible={false}></Column>
                <Column dataField="referencenumber" caption="Reference Number" visible={false}></Column>
                <Column dataField="rOriginaldetail" caption="Original Detail" visible={false}></Column>
                <Column dataField="comment" caption="Comment" visible={false}></Column>
                <Column dataField="userdefinedcode1" caption="User Defined Code 1" visible={false}></Column>
                <Column dataField="userdefinedcode2" caption="User Defined Code 2" visible={false}></Column>
                <Column dataField="userdefinedcode3" caption="User Defined Code 3" visible={false}></Column>
                <Column dataField="userdefinedcode4" caption="User Defined Code 4" visible={false}></Column>
                <Column dataField="userdefinedcode5" caption="User Defined Code 5" visible={false}></Column>
                <Column dataField="userDefinedComment" caption="User Defined Comment" visible={false}></Column>
                <Column dataField="quantityordered" caption="Quantity Ordered" visible={false}></Column>
                <Column dataField="quantityshipped" caption="Quantity Shipped" visible={false}></Column>
                <Column dataField="quantitybackorder" caption="Quantity Backorder" visible={false}></Column>
                <Column dataField="shipmethod" caption="Ship Method" visible={false}></Column>
                <Column dataField="originalquantityordered" caption="Original Quantity Ordered" visible={false}></Column>
                <Column dataField="cogsamount" caption="COGS Amount" visible={false}></Column>
                <Column dataField="rParentdetail" caption="Parent Detail" visible={false}></Column>
                <Column dataField="userdefinedreference1" caption="User Defined Reference 1" visible={false}></Column>
                <Column dataField="userdefinedreference2" caption="User Defined Reference 2" visible={false}></Column>
                <Column dataField="userdefinedreference3" caption="User Defined Reference 3" visible={false}></Column>
                <Column dataField="userdefinedreference4" caption="User Defined Reference 4" visible={false}></Column>
                <Column dataField="userdefinedreference5" caption="User Defined Reference 5" visible={false}></Column>
                <Column dataField="originalorderamount" caption="Original Order Amount" visible={false}></Column>
                <Column dataField="rOriginalreplicatekey" caption="Original Replicate Key" visible={false}></Column>
                <Column dataField="rFees" caption="Fees" visible={false}></Column>
                <Column dataField="feesadded" caption="Fees Added" visible={false}></Column>
                <Column dataField="feesincluded" caption="Fees Included" visible={false}></Column>
                <Column dataField="processflag" caption="Process Flag" visible={false}></Column>
                <Column dataField="customeritem" caption="Customer Item" visible={false}></Column>
                <Column dataField="noninvitemdescription" caption="Non-Inventory Item Description" visible={false}></Column>
                <Column dataField="foreignunitprice" caption="Foreign Unit Price" visible={false}></Column>
                <Column dataField="foreignamount" caption="Foreign Amount" visible={false}></Column>
                <Column dataField="foreigncogsamount" caption="Foreign COGS Amount" visible={false}></Column>
                <Column dataField="foreignoriginalorderamount" caption="Foreign Original Order Amount" visible={false}></Column>
                <Column dataField="foreignfeesadded" caption="Foreign Fees Added" visible={false}></Column>
                <Column dataField="foreignfeesincluded" caption="Foreign Fees Included" visible={false}></Column>
                <Column dataField="alternatedescription" caption="Alternate Description" visible={false}></Column>
                <Column dataField="linenumber" caption="Line Number" visible={false}></Column>
                <Column dataField="productionquantity" caption="Production Quantity" visible={false}></Column>
                <Column dataField="consigneeitem" caption="Consignee Item" visible={false}></Column>
                <Column dataField="freightunitcharge" caption="Freight Unit Charge" visible={false}></Column>
                <Column dataField="feetype" caption="Fee Type" visible={false}></Column>
                <Column dataField="componentcostdiscount" caption="Component Cost Discount" visible={false}></Column>
                <Column dataField="userdefinedcode6" caption="User Defined Code 6" visible={false}></Column>
                <Column dataField="userdefinedcode7" caption="User Defined Code 7" visible={false}></Column>
                <Column dataField="userdefinedcode8" caption="User Defined Code 8" visible={false}></Column>
                <Column dataField="userdefinedcode9" caption="User Defined Code 9" visible={false}></Column>
                <Column dataField="userdefinedcode10" caption="User Defined Code 10" visible={false}></Column>
                <Column dataField="userdefineddate1" caption="User Defined Date 1" dataType="date" visible={false}></Column>
                <Column dataField="userdefineddate2" caption="User Defined Date 2" dataType="date" visible={false}></Column>
                <Column dataField="userdefineddate3" caption="User Defined Date 3" dataType="date" visible={false}></Column>
                <Column dataField="userdefineddate4" caption="User Defined Date 4" dataType="date" visible={false}></Column>
                <Column dataField="userdefineddate5" caption="User Defined Date 5" dataType="date" visible={false}></Column>
                <Column dataField="userdefineddate6" caption="User Defined Date 6" dataType="date" visible={false}></Column>
                <Column dataField="userdefineddate7" caption="User Defined Date 7" dataType="date" visible={false}></Column>
                <Column dataField="userdefineddate8" caption="User Defined Date 8" dataType="date" visible={false}></Column>
                <Column dataField="userdefineddate9" caption="User Defined Date 9" dataType="date" visible={false}></Column>
                <Column dataField="userdefineddate10" caption="User Defined Date 10" dataType="date" visible={false}></Column>
                <Column dataField="userdefinedquantity1" caption="User Defined Quantity 1" visible={false}></Column>
                <Column dataField="userdefinedquantity2" caption="User Defined Quantity 2" visible={false}></Column>
                <Column dataField="userdefinedquantity3" caption="User Defined Quantity 3" visible={false}></Column>
                <Column dataField="userdefinedquantity4" caption="User Defined Quantity 4" visible={false}></Column>
                <Column dataField="userdefinedquantity5" caption="User Defined Quantity 5" visible={false}></Column>
                <Column dataField="userdefinedquantity6" caption="User Defined Quantity 6" visible={false}></Column>
                <Column dataField="userdefinedquantity7" caption="User Defined Quantity 7" visible={false}></Column>
                <Column dataField="userdefinedquantity8" caption="User Defined Quantity 8" visible={false}></Column>
                <Column dataField="userdefinedquantity9" caption="User Defined Quantity 9" visible={false}></Column>
                <Column dataField="userdefinedquantity10" caption="User Defined Quantity 10" visible={false}></Column>
                <Column dataField="userdefinedreference6" caption="User Defined Reference 6" visible={false}></Column>
                <Column dataField="userdefinedreference7" caption="User Defined Reference 7" visible={false}></Column>
                <Column dataField="userdefinedreference8" caption="User Defined Reference 8" visible={false}></Column>
                <Column dataField="userdefinedreference9" caption="User Defined Reference 9" visible={false}></Column>
                <Column dataField="userdefinedreference10" caption="User Defined Reference 10" visible={false}></Column>
                <Column dataField="freightrateperitem" caption="Freight Rate per Item" visible={false}></Column>
                <Column dataField="handlingchargeperitem" caption="Handling Charge per Item" visible={false}></Column>
                <Column dataField="taggingchargeperitem" caption="Tagging Charge per Item" visible={false}></Column>
                <Column dataField="inventoryreview" caption="Inventory Review" visible={false}></Column>
                <Column dataField="effectivefreight" caption="Effective Freight" visible={false}></Column>
                <Column dataField="reviewedshippedquantity" caption="Reviewed Shipped Quantity" visible={false}></Column>
                <Column dataField="confirmedshippedquantity" caption="Confirmed Shipped Quantity" visible={false}></Column>
                <Column dataField="reviewstage" caption="Review Stage" visible={false}></Column>
                <Column dataField="reviewbackorderflag" caption="Review Backorder Flag" visible={false}></Column>
                <Column dataField="reviewbackorderreason" caption="Review Backorder Reason" visible={false}></Column>
                <Column dataField="confirmbackorderflag" caption="Confirm Backorder Flag" visible={false}></Column>
                <Column dataField="confirmbackorderreason" caption="Confirm Backorder Reason" visible={false}></Column>
                <Column dataField="unitpricechange" caption="Unit Price Change" visible={false}></Column>
                <Column dataField="freightrateperitemchange" caption="Freight Rate per Item Change" visible={false}></Column>
                <Column dataField="handlingchargeperitemchange" caption="Handling Charge per Item Change" visible={false}></Column>
                <Column dataField="excessquantity" caption="Excess Quantity" visible={false}></Column>


                <Toolbar>
                <Item location="before">
                     <Button text="Edit" disabled={!showPopup.id} type="default" onClick={()=>setShowPopup(prevFormData=>({...prevFormData, visible:true}))} />
                 </Item>
                <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item location="after">
                    <GridOptionsButton
                        items={operationDropDownItems}
                        onItemClick={onOperationItemClick}
                        disabled={!selectedDetailRows.length}
                    />
                </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
            <SaleOrderDataEntryPopup showPopup={showPopup} setShowPopup={setShowPopup}/>
            <MassPickNotesPopup
                visible={massPickNotesVisible}
                onClose={closeMassPickNotes}
                selectedRows={selectedDetailRows}
            />
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(ItemOrdersTabResult);